import { API_endpoints } from "../config";

export const statistic3 = async (startDate = "", endDate = ""): Promise<any> => {
    try {
        const response = await fetch(API_endpoints.statistic3, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            credentials: 'include',
            body: JSON.stringify({startDate,endDate}),
        });
        if (!response.ok) {
            const errorData = await response.json();
            throw new Error(errorData.message || "Fehler beim Laden von statistik 3 Daten.");
        }
    

        return await response.json();

        
    } catch (error) {
        console.error("Fehler beim Laden von statistik 3 Daten:", error);
    }
};
